import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Single() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="page-header text-center" style={{backgroundImage: 'url("asset/images/page-header-bg.jpg")'}}>
    <div className="container">
      <h1 className="page-title">Default With Sidebar<span>Single Post</span></h1>
    </div>{/* End .container */}
  </div>{/* End .page-header */}
  <nav aria-label="breadcrumb" className="breadcrumb-nav mb-3">
    <div className="container">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><a href="index.html">Home</a></li>
        <li className="breadcrumb-item"><a href="#">Blog</a></li>
        <li className="breadcrumb-item active" aria-current="page">Default With Sidebar</li>
      </ol>
    </div>{/* End .container */}
  </nav>{/* End .breadcrumb-nav */}
  <div className="page-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-9">
          <article className="entry single-entry">
            <figure className="entry-media">
              <img src="asset/images/blog/single/1.jpg" alt="image desc" />
            </figure>{/* End .entry-media */}
            <div className="entry-body">
              <div className="entry-meta">
                <span className="entry-author">
                  by <a href="#">John Doe</a>
                </span>
                <span className="meta-separator">|</span>
                <a href="#">Nov 22, 2018</a>
                <span className="meta-separator">|</span>
                <a href="#">2 Comments</a>
              </div>{/* End .entry-meta */}
              <h2 className="entry-title">
                Cras ornare tristique elit.
              </h2>{/* End .entry-title */}
              <div className="entry-cats">
                in <a href="#">Lifestyle</a>,
                <a href="#">Shopping</a>
              </div>{/* End .entry-cats */}
              <div className="entry-content editor-content">
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                <p>Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent elementum hendrerit tortor. Sed semper lorem at felis. Vestibulum volutpat, lacus a <a href="#">ultrices sagittis</a>, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</p>
                <div className="pb-1" />{/* End .mb-1 */}
                <img src="asset/images/blog/single/2.jpg" alt="image" className="float-left" />
                <h3>Quisque volutpat mattiseros. </h3>
                <ul>
                  <li>Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti. </li>
                  <li>Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. </li>
                  <li>Sed lectus. Praesent elementum hendrerit tortor. Sed semper lorem at felis. Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</li>
                </ul>
                <div className="pb-1 clearfix" />{/* End .clearfix */}
                <p>Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula <a href="#">sollicitudin laoreet</a> viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti. Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent elementum hendrerit tortor. Sed semper lorem at felis. </p>
                <blockquote>
                  <p>“ Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. ”</p>
                </blockquote>
                <p>Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent elementum hendrerit tortor. Sed semper lorem at felis. Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna. Morbi interdum mollis sapien. Sed ac risus. Phasellus lacinia, magna a ullamcorper laoreet, lectus arcu pulvinar risus, vitae facilisis libero dolor a purus. </p>
                <div className="pb-1" />{/* End .pb-1 */}
                <h3>Morbi interdum mollis sapien.</h3>
                <img src="asset/images/blog/single/3.jpg" alt="image" />
                <p>Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti. Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent <a href="#">elementum hendrerit</a> tortor. Sed semper lorem at felis. Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</p>
                <p>Morbi interdum mollis sapien. Sed ac risus. Phasellus lacinia, magna a ullamcorper laoreet, lectus arcu pulvinar risus, vitae facilisis libero dolor a purus. Sed vel lacus. Mauris nibh felis, adipiscing varius, adipiscing in, lacinia vel, tellus. Suspendisse ac urna. Etiam pellentesque mauris ut lectus. Nunc tellus ante, mattis eget, gravida vitae, ultricies ac, leo. Integer leo pede, ornare a, lacinia eu, vulputate vel, nisl. Suspendisse mauris. Fusce accumsan mollis eros. Pellentesque a diam sit amet mi ullamcorper vehicula. Integer adipiscing risus a sem. Nullam quis massa sit amet nibh viverra malesuada. Nunc sem lacus, accumsan quis, faucibus non, congue vel, arcu. </p>
              </div>{/* End .entry-content */}
              <div className="entry-footer row no-gutters flex-column flex-md-row">
                <div className="col-md">
                  <div className="entry-tags">
                    <span>Tags:</span> <a href="#">photography</a> <a href="#">style</a>
                  </div>{/* End .entry-tags */}
                </div>{/* End .col */}
                <div className="col-md-auto mt-2 mt-md-0">
                  <div className="social-icons social-icons-color">
                    <span className="social-label">Share this post:</span>
                    <a href="#" className="social-icon social-facebook" title="Facebook" target="_blank"><i className="icon-facebook-f" /></a>
                    <a href="#" className="social-icon social-twitter" title="Twitter" target="_blank"><i className="icon-twitter" /></a>
                    <a href="#" className="social-icon social-pinterest" title="Pinterest" target="_blank"><i className="icon-pinterest" /></a>
                    <a href="#" className="social-icon social-linkedin" title="Linkedin" target="_blank"><i className="icon-linkedin" /></a>
                  </div>{/* End .soial-icons */}
                </div>{/* End .col-auto */}
              </div>{/* End .entry-footer row no-gutters */}
            </div>{/* End .entry-body */}
            <div className="entry-author-details">
              <figure className="author-media">
                <a href="#">
                  <img src="asset/images/blog/single/author.jpg" alt="User name" />
                </a>
              </figure>{/* End .author-media */}
              <div className="author-body">
                <div className="author-header row no-gutters flex-column flex-md-row">
                  <div className="col">
                    <h4><a href="#">John Doe</a></h4>
                  </div>{/* End .col */}
                  <div className="col-auto mt-1 mt-md-0">
                    <a href="#" className="author-link">View all posts by John Doe <i className="icon-long-arrow-right" /></a>
                  </div>{/* End .col */}
                </div>{/* End .row */}
                <div className="author-content">
                  <p>Praesent dapibus, neque id cursus faucibus, tortor neque egestas auguae, eu vulputate magna eros eu erat. Aliquam erat volutpat. </p>
                </div>{/* End .author-content */}
              </div>{/* End .author-body */}
            </div>{/* End .entry-author-details*/}
          </article>{/* End .entry */}
          <nav className="pager-nav" aria-label="Page navigation">
            <a className="pager-link pager-link-prev" href="#" aria-label="Previous" tabIndex={-1}>
              Previous Post
              <span className="pager-link-title">Cras iaculis ultricies nulla</span>
            </a>
            <a className="pager-link pager-link-next" href="#" aria-label="Next" tabIndex={-1}>
              Next Post
              <span className="pager-link-title">Praesent placerat risus</span>
            </a>
          </nav>{/* End .pager-nav */}
          <div className="related-posts">
            <h3 className="title">Related Posts</h3>{/* End .title */}
            <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:1
                          },
                          &quot;480&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;768&quot;: {
                              &quot;items&quot;:3
                          }
                      }
                  }">
              <article className="entry entry-grid">
                <figure className="entry-media">
                  <a href="single.html">
                    <img src="asset/images/blog/grid/3cols/post-1.jpg" alt="image desc" />
                  </a>
                </figure>{/* End .entry-media */}
                <div className="entry-body">
                  <div className="entry-meta">
                    <a href="#">Nov 22, 2018</a>
                    <span className="meta-separator">|</span>
                    <a href="#">2 Comments</a>
                  </div>{/* End .entry-meta */}
                  <h2 className="entry-title">
                    <a href="single.html">Cras ornare tristique elit.</a>
                  </h2>{/* End .entry-title */}
                  <div className="entry-cats">
                    in <a href="#">Lifestyle</a>,
                    <a href="#">Shopping</a>
                  </div>{/* End .entry-cats */}
                </div>{/* End .entry-body */}
              </article>{/* End .entry */}
              <article className="entry entry-grid">
                <figure className="entry-media">
                  <a href="single.html">
                    <img src="asset/images/blog/grid/3cols/post-2.jpg" alt="image desc" />
                  </a>
                </figure>{/* End .entry-media */}
                <div className="entry-body">
                  <div className="entry-meta">
                    <a href="#">Nov 21, 2018</a>
                    <span className="meta-separator">|</span>
                    <a href="#">0 Comments</a>
                  </div>{/* End .entry-meta */}
                  <h2 className="entry-title">
                    <a href="single.html">Vivamus ntulla necante.</a>
                  </h2>{/* End .entry-title */}
                  <div className="entry-cats">
                    in <a href="#">Lifestyle</a>
                  </div>{/* End .entry-cats */}
                </div>{/* End .entry-body */}
              </article>{/* End .entry */}
              <article className="entry entry-grid">
                <figure className="entry-media">
                  <a href="single.html">
                    <img src="asset/images/blog/grid/3cols/post-3.jpg" alt="image desc" />
                  </a>
                </figure>{/* End .entry-media */}
                <div className="entry-body">
                  <div className="entry-meta">
                    <a href="#">Nov 18, 2018</a>
                    <span className="meta-separator">|</span>
                    <a href="#">3 Comments</a>
                  </div>{/* End .entry-meta */}
                  <h2 className="entry-title">
                    <a href="single.html">Utaliquam sollicitudin leo.</a>
                  </h2>{/* End .entry-title */}
                  <div className="entry-cats">
                    in <a href="#">Fashion</a>,
                    <a href="#">Lifestyle</a>
                  </div>{/* End .entry-cats */}
                </div>{/* End .entry-body */}
              </article>{/* End .entry */}
              <article className="entry entry-grid">
                <figure className="entry-media">
                  <a href="single.html">
                    <img src="asset/images/blog/grid/3cols/post-4.jpg" alt="image desc" />
                  </a>
                </figure>{/* End .entry-media */}
                <div className="entry-body">
                  <div className="entry-meta">
                    <a href="#">Nov 15, 2018</a>
                    <span className="meta-separator">|</span>
                    <a href="#">4 Comments</a>
                  </div>{/* End .entry-meta */}
                  <h2 className="entry-title">
                    <a href="single.html">Fusce pellentesque suscipit.</a>
                  </h2>{/* End .entry-title */}
                  <div className="entry-cats">
                    in <a href="#">Travel</a>
                  </div>{/* End .entry-cats */}
                </div>{/* End .entry-body */}
              </article>{/* End .entry */}
            </div>{/* End .owl-carousel */}
          </div>{/* End .related-posts */}
          <div className="comments">
            <h3 className="title">3 Comments</h3>{/* End .title */}
            <ul>
              <li>
                <div className="comment">
                  <figure className="comment-media">
                    <a href="#">
                      <img src="asset/images/blog/comments/1.jpg" alt="User name" />
                    </a>
                  </figure>
                  <div className="comment-body">
                    <a href="#" className="comment-reply">Reply</a>
                    <div className="comment-user">
                      <h4><a href="#">Jimmy Pearson</a></h4>
                      <span className="comment-date">November 9, 2018 at 2:19 pm</span>
                    </div>{/* End .comment-user */}
                    <div className="comment-content">
                      <p>Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti. </p>
                    </div>{/* End .comment-content */}
                  </div>{/* End .comment-body */}
                </div>{/* End .comment */}
                <ul>
                  <li>
                    <div className="comment">
                      <figure className="comment-media">
                        <a href="#">
                          <img src="asset/images/blog/comments/2.jpg" alt="User name" />
                        </a>
                      </figure>
                      <div className="comment-body">
                        <a href="#" className="comment-reply">Reply</a>
                        <div className="comment-user">
                          <h4><a href="#">Lena  Knight</a></h4>
                          <span className="comment-date">November 9, 2018 at 2:19 pm</span>
                        </div>{/* End .comment-user */}
                        <div className="comment-content">
                          <p>Morbi interdum mollis sapien. Sed ac risus.</p>
                        </div>{/* End .comment-content */}
                      </div>{/* End .comment-body */}
                    </div>{/* End .comment */}
                  </li>
                </ul>
              </li>
              <li>
                <div className="comment">
                  <figure className="comment-media">
                    <a href="#">
                      <img src="asset/images/blog/comments/3.jpg" alt="User name" />
                    </a>
                  </figure>
                  <div className="comment-body">
                    <a href="#" className="comment-reply">Reply</a>
                    <div className="comment-user">
                      <h4><a href="#">Johnathan Castillo</a></h4>
                      <span className="comment-date">November 9, 2018 at 2:19 pm</span>
                    </div>{/* End .comment-user */}
                    <div className="comment-content">
                      <p>Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</p>
                    </div>{/* End .comment-content */}
                  </div>{/* End .comment-body */}
                </div>{/* End .comment */}
              </li>
            </ul>
          </div>{/* End .comments */}
          <div className="reply">
            <div className="heading">
              <h3 className="title">Leave A Reply</h3>{/* End .title */}
              <p className="title-desc">Your email address will not be published. Required fields are marked *</p>
            </div>{/* End .heading */}
            <form action="#">
              <label htmlFor="reply-message" className="sr-only">Comment</label>
              <textarea name="reply-message" id="reply-message" cols={30} rows={4} className="form-control" required placeholder="Comment *" defaultValue={""} />
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="reply-name" className="sr-only">Name</label>
                  <input type="text" className="form-control" id="reply-name" name="reply-name" required placeholder="Name *" />
                </div>{/* End .col-md-6 */}
                <div className="col-md-6">
                  <label htmlFor="reply-email" className="sr-only">Email</label>
                  <input type="email" className="form-control" id="reply-email" name="reply-email" required placeholder="Email *" />
                </div>{/* End .col-md-6 */}
              </div>{/* End .row */}
              <button type="submit" className="btn btn-outline-primary-2">
                <span>POST COMMENT</span>
                <i className="icon-long-arrow-right" />
              </button>
            </form>
          </div>{/* End .reply */}
        </div>{/* End .col-lg-9 */}
        <aside className="col-lg-3">
          <div className="sidebar">
            <div className="widget widget-search">
              <h3 className="widget-title">Search</h3>{/* End .widget-title */}
              <form action="#">
                <label htmlFor="ws" className="sr-only">Search in blog</label>
                <input type="search" className="form-control" name="ws" id="ws" placeholder="Search in blog" required />
                <button type="submit" className="btn"><i className="icon-search" /><span className="sr-only">Search</span></button>
              </form>
            </div>{/* End .widget */}
            <div className="widget widget-cats">
              <h3 className="widget-title">Categories</h3>{/* End .widget-title */}
              <ul>
                <li><a href="#">Lifestyle<span>3</span></a></li>
                <li><a href="#">Shopping<span>3</span></a></li>
                <li><a href="#">Fashion<span>1</span></a></li>
                <li><a href="#">Travel<span>3</span></a></li>
                <li><a href="#">Hobbies<span>2</span></a></li>
              </ul>
            </div>{/* End .widget */}
            <div className="widget">
              <h3 className="widget-title">Popular Posts</h3>{/* End .widget-title */}
              <ul className="posts-list">
                <li>
                  <figure>
                    <a href="#">
                      <img src="asset/images/blog/sidebar/post-1.jpg" alt="post" />
                    </a>
                  </figure>
                  <div>
                    <span>Nov 22, 2018</span>
                    <h4><a href="#">Aliquam tincidunt mauris eurisus.</a></h4>
                  </div>
                </li>
                <li>
                  <figure>
                    <a href="#">
                      <img src="asset/images/blog/sidebar/post-2.jpg" alt="post" />
                    </a>
                  </figure>
                  <div>
                    <span>Nov 19, 2018</span>
                    <h4><a href="#">Cras ornare tristique elit.</a></h4>
                  </div>
                </li>
                <li>
                  <figure>
                    <a href="#">
                      <img src="asset/images/blog/sidebar/post-3.jpg" alt="post" />
                    </a>
                  </figure>
                  <div>
                    <span>Nov 12, 2018</span>
                    <h4><a href="#">Vivamus vestibulum ntulla nec ante.</a></h4>
                  </div>
                </li>
                <li>
                  <figure>
                    <a href="#">
                      <img src="asset/images/blog/sidebar/post-4.jpg" alt="post" />
                    </a>
                  </figure>
                  <div>
                    <span>Nov 25, 2018</span>
                    <h4><a href="#">Donec quis dui at dolor  tempor interdum.</a></h4>
                  </div>
                </li>
              </ul>{/* End .posts-list */}
            </div>{/* End .widget */}
            <div className="widget widget-banner-sidebar">
              <div className="banner-sidebar-title">ad box 280 x 280</div>{/* End .ad-title */}
              <div className="banner-sidebar">
                <a href="#">
                  <img src="asset/images/blog/sidebar/banner.jpg" alt="banner" />
                </a>
              </div>{/* End .banner-ad */}
            </div>{/* End .widget */}
            <div className="widget">
              <h3 className="widget-title">Browse Tags</h3>{/* End .widget-title */}
              <div className="tagcloud">
                <a href="#">fashion</a>
                <a href="#">style</a>
                <a href="#">women</a>
                <a href="#">photography</a>
                <a href="#">travel</a>
                <a href="#">shopping</a>
                <a href="#">hobbies</a>
              </div>{/* End .tagcloud */}
            </div>{/* End .widget */}
            <div className="widget widget-text">
              <h3 className="widget-title">About Blog</h3>{/* End .widget-title */}
              <div className="widget-text-content">
                <p>Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, pulvinar nunc sapien ornare nisl.</p>
              </div>{/* End .widget-text-content */}
            </div>{/* End .widget */}
          </div>{/* End .sidebar sidebar-shop */}
        </aside>{/* End .col-lg-3 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .page-content */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Single